import { lookup, type VarlessCopyId } from '@npc/copy'

import { t } from '../../../copy'

/**
 * 项目中心文案。id 以 `pjhub.` 开头，源在 `docs/copy/pjhub.yaml`。
 *
 * `make generate-copy` 跑完之后走生成物；还没跑时 lookup 会空，
 * 用与 yaml 逐字相同的桥接表——否则 `/projects` 会在生成之前把整份
 * screens 用例炸掉。生成之后以生成物为准。
 */
export const HUB_COPY = {
  'pjhub.title': '项目中心',
  'pjhub.subtitle':
    '所有你能进的项目都在这儿。上面一条是跨项目的真实汇总，下面按「要你处理的排最前」列出来。',
  'pjhub.subtitle.unverified': '汇总数字暂时读不到。列表还在，能进项目。',
  'pjhub.action.create': '新建项目',
  'pjhub.action.retry': '重试',
  'pjhub.search.placeholder': '搜项目名或简介',
  'pjhub.filter.all': '全部',
  'pjhub.filter.needs_attention': '需处理',
  'pjhub.filter.unverified': '未核验',
  'pjhub.stat.projects': '项目',
  'pjhub.stat.healthy': '健康',
  'pjhub.stat.needs_attention': '需处理',
  'pjhub.stat.running_tasks': '运行中任务',
  'pjhub.stat.running_releases': '运行中发布',
  'pjhub.value.unverified': '未核验',
  'pjhub.col.name': '名称',
  'pjhub.col.health': '健康',
  'pjhub.col.env': '正式 / 测试',
  'pjhub.col.recent_task': '最近任务',
  'pjhub.col.recent_release': '最近发布',
  'pjhub.col.resource': '资源异常',
  'pjhub.resource.has': '有要留意的',
  'pjhub.resource.none': '没有',
  'pjhub.col.activity': '最后活动',
  'pjhub.notice.unverified.title': '汇总还没核验',
  'pjhub.notice.unverified.body':
    '读不到的数字现在是「未核验」，不是 0——填 0 会让你以为真的没有任务在跑。',
  'pjhub.notice.unverified.why':
    '0 和「不知道」是两件事。读不到的时候写 0，你会以为没事；写「未核验」，你才知道要么重试要么先别信这个数。',
  'pjhub.notice.missing_fields.body':
    '有的汇总数字还读不到。读不到的写成「未核验」，不写成 0。',
  'pjhub.notice.not_switcher.title': '这一页不是项目切换器',
  'pjhub.notice.not_switcher.body':
    '它是管理入口：能新建、能导入、能比较。切项目也从这儿走——顶栏没有下拉切换器，当前项目由网址决定。',
  'pjhub.empty.title': '把已经上线的项目导进来',
  'pjhub.empty.body':
    '你不用逐个字段填。点「把一个现成项目接进来」，平台给你一段话，你转发给当初帮你做这个项目的 AI，它会把仓库、服务器、域名、环境和付费服务整理好交回来。也可以先新建一个空项目。',
  'pjhub.loading.title': '正在读取项目列表',
  'pjhub.loading.hint': '已经发出请求，还没有回应。不会先拿上一次的数据顶着。',
  'pjhub.error.title': '没能读到项目列表',
  'pjhub.error.body': '这不是「你没有项目」。列表暂时读不到，所以数字写成未核验，不写成 0。',
  'pjhub.builtin': '内置',
  'pjhub.sort.hint': '要你处理的排最前',
  'pjhub.filter.empty': '没有符合这些条件的项目。',
  'pjhub.new.title': '新建项目',
  'pjhub.new.subtitle': '先起个名字。标识可以先空着，我来补。',
  'pjhub.new.name': '项目叫什么',
  'pjhub.new.slug': '标识，可不填',
  'pjhub.new.submitting': '正在建',
} as const

export type HubCopyId = keyof typeof HUB_COPY

export function hubT(id: HubCopyId): string {
  if (lookup(id)) return t(id as VarlessCopyId)
  return HUB_COPY[id]
}
